import { BorderRadius, Color, getShadow, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ReportContentContainer = styled.div`
  border-radius: ${BorderRadius.R12};
  outline: 1px solid ${Color.Grey200};
  overflow: hidden;
  ${getShadow('raisedLight')};
`

export const ReportContentWrapper = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: ${Color.White};
`

export const PreviewSkeletonWrapper = styled.div`
  padding: ${Spacing.S16};
`
